import { Diagnostic } from "@siteimprove/alfa-act";
import { DOM } from "@siteimprove/alfa-aria";
import { Element } from "@siteimprove/alfa-dom";
import { Option } from "@siteimprove/alfa-option";
import { Predicate } from "@siteimprove/alfa-predicate";
import { Err, Ok } from "@siteimprove/alfa-result";
import { expectation } from "../act/expectation.js";
import { Question } from "../act/question.js";
const { isPerceivableForAll } = DOM;
const { isElement } = Element;
const { and } = Predicate;
function mediaTranscript(transcript, transcriptLink, device, kind) {
    return {
        1: transcript.map((transcript) => {
            if (transcript.isNone()) {
                return transcriptLink.map((transcriptLink) => {
                    if (transcriptLink.isNone()) {
                        return Option.of(Outcomes.HasNoTranscriptLink(kind));
                    }
                    if (transcriptLink
                        .filter(and(isElement, isPerceivableForAll(device)))
                        .isNone()) {
                        return Option.of(Outcomes.HasNonPerceivableLink(kind));
                    }
                    return Option.of(Outcomes.HasPerceivableLink(kind));
                });
            }
            return expectation(transcript.some(and(isElement, isPerceivableForAll(device))), () => Outcomes.HasPerceivableTranscript(kind), () => Outcomes.HasNonPerceivableTranscript(kind));
        }),
    };
}
export function audioTranscript(target, device) {
    const alt = Question.of("transcript", target, `Where is the transcript that describes the content of the \`<audio>\` element?`);
    const label = Question.of("transcript-link", target, `Where is the link pointing to a perceivable transcript that describes the content of the \`<audio>\` element?`);
    return mediaTranscript(alt, label, device, "<audio>");
}
export function videoTranscript(target, device) {
    const alt = Question.of("transcript", target, `Where is the transcript that describes the content of the \`<video>\` element?`);
    const label = Question.of("transcript-link", target, `Where is the link pointing to a perceivable transcript that describes the content of the \`<video>\` element?`);
    return mediaTranscript(alt, label, device, "<video>");
}
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.HasPerceivableTranscript = (kind) => Ok.of(Diagnostic.of(`The \`${kind}\` element has a transcript that is perceivable`));
    Outcomes.HasPerceivableLink = (kind) => Ok.of(Diagnostic.of(`The \`${kind}\` element has a link that is perceivable`));
    Outcomes.HasNoTranscriptLink = (kind) => Err.of(Diagnostic.of(`The \`${kind}\` element does not have a transcript`));
    Outcomes.HasNonPerceivableLink = (kind) => Err.of(Diagnostic.of(`The \`${kind}\` has a link to transcript, but the link is not perceivable`));
    Outcomes.HasNonPerceivableTranscript = (kind) => Err.of(Diagnostic.of(`The \`${kind}\` element has a transcript that is not perceivable`));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=media-transcript.js.map